import config from '../../config.js';
import products from '../../utils/products.js';
import fieldUtils from '../../utils/step.fields.utils.js';

const secondOccupation = () => {
    return [
        {
            key: `occupation_1_type`
        },
    ];
};

const convictions = (driver, n) => {
    const result = [
        {...fieldUtils.conviction_x_type(driver, n)},
        {...fieldUtils.conviction_x_points(driver, n)},
        {...fieldUtils.conviction_x_ban(driver, n)},
    ];

    if (n < config[products.quad].mot_convictions) {
        result.push({
            ...fieldUtils.conviction_x_more(driver, n),
            children: convictions(driver, n + 1),
            required_children: value => value === true,
        });
    }
    return result;
};

const step_schema_quad = [
    //source
    //Vehicle
    {
        key: 'vrm'
    },
    {
        key: 'make',
        skip_question: true,
    },
    {
        key: 'model',
        skip_question: true,
    },
    {
        key: 'year',
        skip_question: true,
    },
    {
        key: 'engine',
        required: true,
        skip_question: true,
    },
    {
        key: 'ncb_years_private'
    },
    //Driver
    {
        key: 'driver_details',
        info: 'Details',
        extra_children: [
            {
                key: 'title',
                variant: 'inline'
            },
            {key: 'first_name'},
            {key: 'last_name'}
        ]
    },
    {
        key: 'telephone'
    },
    {
        key: 'email'
    },
    {
        key: 'date_of_birth'
    },
    {
        key: 'postcode'
    },
    {
        key: 'address1',
        skip_question: true
    },
    {
        key: 'address2',
        skip_question: true
    },
    {
        key: 'address3',
        skip_question: true
    },
    {
        key: 'address4',
        skip_question: true
    },
    {
        key: 'city',
        skip_question: true
    },
    {
        key: 'licence_type'
    },
    {
        key: 'occupation_0_type'
    },
    {
        key: 'occupation_0_more',
        children: secondOccupation(),
        required_children: value => value === true
    },
    {
        key: 'has_convictions_more',
        children: convictions('Proposer\'s', 0),
        required_children: value => value === true
    },
    {
        key: 'has_criminal_convictions'
    },
    //policy
    {
        key: 'cover_type'
    },
    {
        key: 'cover_date'
    },
    {
        key: 'cover_duration',
        label: 'How long do you want this cover',
        type: 'select',
        value: '',
        options: [],
        required: true
    },
    {
        key: 'marketing',
        extra_children: [
            {key: 'marketing_phone'},
            {key: 'marketing_email'},
            {key: 'marketing_sms'}
        ]
    },
    {
        key: 'end',
    },
];
export default step_schema_quad;
